import './styles.scss'

import React, { useCallback } from 'react'
import { Badge } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import ReactTooltip from 'react-tooltip'
import { getStaticImage } from 'utils/statics'
import { seenTicket } from 'redux/mnemonics/actions'

import {
  getUnreadMessages, getBadgeColorClass, getBadgeContainerClassname,
  getTooltip
} from './handlers'

/**
 * MnemonicsBadge
 * @param {object} props
 * @param {string} [props.userId] Only required for location default
 * @param {'poolMain'|'poolAssigned'|'search'|'userCard'|'inchat'} [props.location] By default is 'default'
 * @param {boolean} [props.isSidebar] Add class for sidebar
 * @param {boolean} [props.showRealNumber] Display real number, by default display 99+ when the number of 99 is exceeded
 * @param {number} [props.value] Overwrite current mnmonics value in redux
 * @param {boolean} [props.showTooltip] Display or not tooltip
 *
 */
function MnemonicsBadge(props) {
  const {
    userId, subjectId, location = 'default', isSidebar = false, isRead = false,
    showRealNumber = false, value = 0, showTooltip = false, customBadgeColor, onFinish
  } = props

  const dispatch = useDispatch()
  const mnemonics = useSelector(store => store.mnemonics)
  const numMsg = getUnreadMessages(mnemonics, { location, userId, currentUnreadMsg: value })

  const onRemove = useCallback((e) => {
    e.stopPropagation()

    dispatch(seenTicket({
      ticketId: userId,
      subjectId,
      removeByOperator: true,
      onFinish
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  // Don't show component for users without messages
  if (!numMsg) return null

  const badgeColor = getBadgeColorClass(numMsg)
  const classname = getBadgeContainerClassname({ location, isSidebar })
  const tooltip = getTooltip({ location, showTooltip })
  const msgDisplay = showRealNumber
    ? numMsg
    : numMsg > 99 ? '99+' : numMsg

  return (
    <div
      className={`mnemonics-badge ${classname || ''}`}
      data-tip={tooltip ? I18n.t(tooltip) : ''}
    >
      <Badge color={customBadgeColor ? customBadgeColor : badgeColor} pill>
        {msgDisplay}
        {isRead &&
          <img
            style={{ width:12, height:12 }}
            className='closeMnemonics'
            src={getStaticImage('/icons/orange-brand/icon-close.svg')}
            alt='Close'
            onClick={onRemove}
          />
        }
      </Badge>
      {
        tooltip
          ? <ReactTooltip place='right' multiline={true} />
          : null
      }
    </div>
  )
}

export default MnemonicsBadge
